import { EvtHeader } from "components/header";
import React from "react";
import CsatForm from "../form";

const CreateSurvey = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Survey" />
      <div className="p-6">
        <CsatForm />
      </div>
    </div>
  );
};

export default CreateSurvey;
